import { toIsoSeoDate } from "@/shared/lib/seo-date"

const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/
const NAIVE_WIRE_DATE = /^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})$/
const OFFSET_ISO_DATE = /^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/i
const LEGACY_SHORT_DATE = /^\d{2}\s*\.\s*\d{1,2}\s*\.\s*\d{1,2}\.?$/

const validCalendarDate = (value: string): string | undefined =>
  // 날짜만 있는 문자열은 UTC로 해석되며, 여기서는 잘못된 날짜의 자동 보정 여부만 검사한다.
  // 반환값은 날짜 문자열로 유지하고, 자정이나 오프셋을 임의로 덧붙인 DateTime을 만들지 않는다.
  toIsoSeoDate(value)?.slice(0, 10) === value ? value : undefined

/** 리뷰 제공 측에서 오프셋을 제거한 경우 날짜 단위의 정밀도를 보존한다. */
export const normalizeHospitalReviewDate = (value?: string): string | undefined => {
  const normalized = value?.trim()
  if (!normalized) return undefined
  if (CALENDAR_DATE.test(normalized)) return validCalendarDate(normalized)

  const naive = normalized.match(NAIVE_WIRE_DATE)
  if (naive) {
    const [, date, hour, minute, second] = naive
    if (Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return undefined
    return validCalendarDate(date)
  }

  const offsetDate = normalized.match(OFFSET_ISO_DATE)
  if (offsetDate) {
    const [, date, hour, minute, second = "0"] = offsetDate
    // Date가 잘못된 날짜나 시각을 자동 보정하기 전에 원본 값을 검증한다.
    if (!validCalendarDate(date) || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) {
      return undefined
    }
    return toIsoSeoDate(normalized)
  }

  if (LEGACY_SHORT_DATE.test(normalized)) {
    return toIsoSeoDate(normalized)
  }
  // 해석이 모호한 현지 시각을 실행 환경의 시간대에 따라 달라지는 파서에 맡기지 않는다.
  return undefined
}

/** 레코드 생성일인 createAt은 게시일이 아니므로 authorAt을 대체해서는 안 된다. */
export const resolveHospitalReviewDate = ({ authorAt }: {
  authorAt?: string
}): string | undefined => normalizeHospitalReviewDate(authorAt)
